import { TranslateModule } from '@ngx-translate/core';
import { Component, inject, OnInit, signal } from '@angular/core';
import { ContactService } from '../Services/contactUs.service';
import { CommonModule } from '@angular/common';
import { SettingsModel } from "../../../shared/Model/setting.model"
import { ContactUsComponent } from "../../../shared/Componet/contact/Component/contact-us.component";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SharedModule } from '../../../shared/Module/shared.module';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-contactus-home',
  imports: [TranslateModule, CommonModule, ContactUsComponent, SharedModule],
  templateUrl: './contactus-home.component.html',
  styleUrl: './contactus-home.component.css'
})
export class ContactusHomeComponent implements OnInit {
  settings = signal<SettingsModel[]>([])
  mapUrl: SafeResourceUrl | null = null;
  private subs = new Subscription();   // container for all subscriptions



  private contactService = inject(ContactService)
  private sanitizer = inject(DomSanitizer)

  ngOnInit(): void {
    const sub = this.contactService.getAllSettings().subscribe({
      next: (data) => {
        this.settings.set(data.value)

        // const lat = this.settings()[0]?.lat;
        // const lng = this.settings()[0]?.long;
        // console.log(this.settings)

        const lat = 30.0759;
        const lng = 31.2812;

        if (lat && lng) {
          const embedUrl = `https://maps.google.com/maps?q=${lat},${lng}&hl=ar&z=14&output=embed`;
          this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
        }

      },
      error: (err) => {
        console.error('Error loading settings', err);
      }
    });
    this.subs.add(sub);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }
}

